var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnStorygameProfileEdit = function SvgIcnStorygameProfileEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.5h5M10.625 5.625 2.5 13.75v3.75h3.75l8.125-8.125m-3.75-3.75L13.75 2.5l3.75 3.75-3.125 3.125m-3.75-3.75 3.75 3.75",
    stroke: "#fff",
    strokeOpacity: 0.9,
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIcnStorygameProfileEdit;